import './MessageAttachments.scss';
import { Attachment } from '../../Chat/Chat';
import AttachmentIcon from '../../CMComposer/Attachments/AttachmentItem/AttachemntItemIcon';
import { useState } from 'react';
import MessageAttachmentModal from './MessageAttachmentModal/MessageAttachmentModal';

type MessageAttachmentsProps = {
  attachments: Attachment[];
};

export const getAttachmentType = (attachment: Attachment) => {
  const { filename } = attachment;
  const extension = filename.split('.').pop()?.toLowerCase();
  return extension;
};
/**
 * Renders a list of message attachments.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.attachments - An array of attachment objects.
 * @returns {JSX.Element|null} The rendered component or null if no attachments are present.
 */
const MessageAttachments: React.FC<MessageAttachmentsProps> = ({ attachments }) => {
  const [attachmentId, setAttachmentId] = useState<string | null>(null);

  const attachentsQuantity = attachments.length;

  const previewAttachment = (attachmentId: string) => {
    setAttachmentId(attachmentId);
  };

  const handleCloseAttachmentImage = () => {
    setAttachmentId(null);
  };

  if (!attachentsQuantity) {
    return null;
  }

  return (
    <>
      <div className="attachments">
        <div className="attachments__preview">
          {attachments.map((at, idx) => (
            <div
              className="attachments__item"
              key={`${at.attachmentId}-${idx}`}
              onClick={() => previewAttachment(at.attachmentId)}
            >
              <i className="attachments__icon">
                <AttachmentIcon attachamentType={getAttachmentType(at)!} />
              </i>
            </div>
          ))}
        </div>
        <span className="attachments__count">
          {attachentsQuantity} Attachment{attachentsQuantity > 1 ? 's' : ''}
        </span>
      </div>

      {attachmentId && <MessageAttachmentModal attachments={attachments} handleClose={handleCloseAttachmentImage} />}
    </>
  );
};

export default MessageAttachments;
